const steps = [
  {
    title: "Set the topics",
    description:
      "Choose AI topics you care about, and we’ll tailor your updates around them.",

    bgStyle: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%)",
  },
  {
    title: "Set the vibe",
    description:
      "Snappy? Technical? Shakespeare? You decide how your newsletter sounds.",

    bgStyle: "linear-gradient(135deg, #fef7f0 0%, #fed7aa 50%, #fdba74 100%)",
  },
  {
    title: "Set the schedule",
    description: "Your inbox, your way. Choose when your updates land.",

    bgStyle: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 50%, #bfdbfe 100%)",
  },
  {
    title: "Test your setup",
    description:
      "Once you're happy, send yourself a test email to see it in action",

    bgStyle: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 50%, #bbf7d0 100%)",
  },
];

export default function NewsletterSteps() {
  return (
    <div className="w-full max-w-md mx-auto relative mb-16">
      {/* Vertical Stack with Rotation and Overlap */}
      <div className="relative h-[1000px] sm:h-[1100px] md:h-[1200px]">
        {steps.map((step, index) => {
          // Calculate rotation and offset for each card
          const rotation = (index - 1.5) * 6; // -9, -3, 3, 9 degrees (less rotation)
          const offsetY = index * 270; // 0, 100, 200, 300px (more vertical spacing)
          const offsetX = index % 2 === 0 ? -30 : 30; // Alternate left/right (more horizontal spread)
          const zIndex = steps.length - index; // Higher z-index for later cards

          return (
            <div
              key={index}
              className="absolute w-64 sm:w-72 md:w-80 h-64 sm:h-72 md:h-80"
              style={{
                transform: `translate(${offsetX}px, ${offsetY}px) rotate(${rotation}deg)`,
                zIndex: zIndex,
                left: "50%",
                top: 0,
                marginLeft: "-128px", // Half of w-64
              }}
            >
              <div className="relative overflow-hidden rounded-xl transition-all duration-300 group hover:scale-105 hover:rotate-0 w-full h-full">
                {/* Background Gradient */}
                <div
                  className="absolute inset-0"
                  style={{ background: step.bgStyle }}
                ></div>

                {/* Content */}
                <div className="relative z-10 p-4 sm:p-6 h-full flex flex-col justify-center text-center">
                  <div className="flex justify-center mb-3 sm:mb-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm sm:text-base font-bold shadow-lg">
                      {index + 1}
                    </div>
                  </div>
                  <h3 className="font-bold text-base sm:text-lg md:text-xl mb-2 sm:mb-3 text-gray-900">
                    {step.title}
                  </h3>
                  <p className="text-gray-700 text-xs sm:text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
